import {useCallback, useState} from 'react';

type UseVelaChatOptions = {
  ids: string[];
};

export function useVelaChat({ids}: UseVelaChatOptions) {
  const [askedId, setAskedId] = useState<string | null>(null);
  const [turn, setTurn] = useState(0);

  const currentId = askedId !== null && ids.includes(askedId) ? askedId : ids[0] ?? null;

  const ask = useCallback(
    (id: string) => {
      if (id === currentId) return;
      setAskedId(id);
      setTurn(value => value + 1);
    },
    [currentId],
  );

  return {currentId, turn, ask};
}
